import React from 'react'
import icon from '../icons.svg'
import {localestr,uid} from '../utils.js'

function EditImg({Capt,Value,setVal,width1,width2,height2,img_width=300,img_height=300,img_transp=true,disabled=false}){

    function onImageChange(e){
        if (e.target.files && e.target.files[0]) {
            let img = e.target.files[0]
            let reader = new FileReader()
            reader.readAsDataURL(img)
            reader.onload = function(){
                const img_ = new Image()
                const canvas = document.createElement('canvas')
                const ctx = canvas.getContext('2d')
                img_.src=reader.result
                img_.onload = function(){
                    let decolor=img_transp
                    canvas.width=img_width
                    canvas.height=img_height
                    const k1=img_width/img_.width
                    const k2=img_height/img_.height
                    let k=k2
                    if(k2>k1 && k1/k2<0.6) k=k2*0.6
                    else if(k1>k2 && k2/k1<0.6) k=k1*0.6
                    else if(k1>k2 && k2/k1>=0.6) k=k1
                    if(k>1.5) k=1.5
                    let l=0
                    let t=0
                    const w=parseInt(img_.width*k)
                    const h=parseInt(img_.height*k)
                    if(w!==img_width) l=(img_width-w)/2
                    if(h!==img_height) t=(img_height-h)/2
                    if(!img_transp){
                        if(l || t){
                            ctx.filter = 'blur(20px)'
                            ctx.drawImage(img_, -200, -200, canvas.width + 500, canvas.height + 500)
                            ctx.filter = "none";
                        }
                    }
                    ctx.drawImage(img_, l,t,w,h)
                    let image = ctx.getImageData(l, t, w, h)
                    let imageData = image.data
                    if(imageData[3]<255) decolor=false
                    if(decolor){
                        //зробити прозрачним фон
                        for(let y=0;y<h;y++){
                            for(let x=0;x<w;x++){
                                let z=(y*w+x)*4
                                let l_=0
                                let t_=0
                                if(x>0) l_=imageData[z-1]
                                if(y>0) t_=imageData[z-w*4+3]
                                const s_color=imageData[z]+imageData[z+1]+imageData[z+2]
                                let min_color=imageData[z]<imageData[z+1]?imageData[z]:imageData[z+1]
                                if(min_color>imageData[z+2]) min_color=imageData[z+2]
                                if(s_color>750&(!l_||!t_)){
                                    image.data[z]=0
                                    image.data[z+1]=0
                                    image.data[z+2]=0
                                    image.data[z+3]=0
                                } else if(min_color>215&(l_<50||t_<50)){
                                    image.data[z]-=min_color
                                    image.data[z+1]-=min_color
                                    image.data[z+2]-=min_color
                                    image.data[z+3]=255-min_color
                                }
                            }
                        }
                        for(let x=w-1;x>-1;x--){
                            for(let y=h-1;y>-1;y--){
                                let z=(y*w+x)*4
                                let l_=0
                                let t_=0
                                if(x<w-1) l_=imageData[z+7]
                                if(y<h-1) t_=imageData[z+w*4+3]
                                const s_color=imageData[z]+imageData[z+1]+imageData[z+2]
                                let min_color=imageData[z]<imageData[z+1]?imageData[z]:imageData[z+1]
                                if(min_color>imageData[z+2]) min_color=imageData[z+2]
                                if(s_color>750&(!l_||!t_)){
                                    image.data[z]=0
                                    image.data[z+1]=0
                                    image.data[z+2]=0
                                    image.data[z+3]=0
                                } else if(min_color>215&(l_<50||t_<50)){
                                    image.data[z]-=min_color
                                    image.data[z+1]-=min_color
                                    image.data[z+2]-=min_color
                                    image.data[z+3]=255-min_color
                                }
                            }
                        }
                        for(let x=0;x<w;x++){
                            for(let y=0;y<h;y++){
                                let z=(y*w+x)*4
                                let l_=0
                                let t_=0
                                if(x>0) l_=imageData[z-1]
                                if(y>0) t_=imageData[z-w*4+3]
                                const s_color=imageData[z]+imageData[z+1]+imageData[z+2]
                                let min_color=imageData[z]<imageData[z+1]?imageData[z]:imageData[z+1]
                                if(min_color>imageData[z+2]) min_color=imageData[z+2]
                                if(s_color>750&(!l_||!t_)){
                                    image.data[z]=0
                                    image.data[z+1]=0
                                    image.data[z+2]=0
                                    image.data[z+3]=0
                                } else if(min_color>215&(l_<50||t_<50)){
                                    image.data[z]-=min_color
                                    image.data[z+1]-=min_color
                                    image.data[z+2]-=min_color
                                    image.data[z+3]=255-min_color
                                }
                            }
                        }
                        
                        ctx.putImageData(image, l, t)
                    }
                    if(img_transp) setVal(canvas.toDataURL())
                    else if ( /^((?!chrome|android).)*safari/i.test(navigator.userAgent)) setVal(canvas.toDataURL('image/jpeg')) //Сафарі не підтримує
                    //else if (typeof window.InstallTrigger !== 'undefined') setVal(canvas.toDataURL('image/jpeg')) //firefox
                    else setVal(canvas.toDataURL('image/webp'))
                    //else setVal(canvas.toDataURL('image/jpeg'))
                }
                //setVal(reader.result)
            }
            
          }
              
    }
    const fid=uid()

    return(
        <div style={{display:'inline-flex',flexDirection:'row',margin:'inherit',maxWidth:parseInt(width1)*2+parseInt(width2)*2+'px'}}>
            <div style={{display:'inline-flex',width:width1+'px',boxSizing:'border-box',height:'24px',flexBasis:width1+'px',flexGrow:parseInt(width1)}}>{Capt}</div>
            <div style={{display:'inline-flex',width:width2+'px',boxSizing:'border-box',height:height2+'px',flexBasis:width2+'px',border:'1px solid #0002'}}>
            <label htmlFor={fid} style={{width:'100%',height:'100%'}}>
                <div className='imgContainer' style={{width:'100%',height:'100%'}}>
                <img src={Value} style={{width:width2+'px',height:height2+'px',verticalAlign:'top',objectFit:'contain'}} alt=''/>
                <input id={fid} style={{display:'none'}} type="file" accept="image/png, image/jpg, image/gif, image/jpeg, image/webp" onChange={onImageChange}/>
                <div className='imgButton' onClick={e=>{e.preventDefault();setVal('')}} title={localestr('Очистити')}><img src={icon+'#canBut'} alt={localestr('Очистити')} /></div>
                </div>
            </label>


            </div>
        </div>
    )
}

export default EditImg